export default {
  backendUrl: `${process.env.REACT_APP_API_ENDPOINT || 'http://localhost:5000'}/api`,
};
